import type {
  CreatePaymentRequest,
  PaymentResponse,
} from '../types/payment';
import { api } from './api';

export async function createPayment(
  body: CreatePaymentRequest,
): Promise<PaymentResponse> {
  const { data } = await api.post<PaymentResponse>('/payments', body);
  return data;
}

export async function getPaymentsByTaxCase(
  taxCaseId: string,
): Promise<PaymentResponse[]> {
  const { data } = await api.get<PaymentResponse[]>(
    `/payments/tax-case/${taxCaseId}`,
  );
  return data;
}

export async function markPaymentPaid(id: string): Promise<PaymentResponse> {
  const { data } = await api.patch<PaymentResponse>(
    `/payments/${id}/mark-paid`,
  );
  return data;
}

export async function markPaymentOverdue(id: string): Promise<PaymentResponse> {
  const { data } = await api.patch<PaymentResponse>(
    `/payments/${id}/mark-overdue`,
  );
  return data;
}

export async function confirmPayment(
  id: string,
  note?: string,
  proofOfPaymentDocumentId?: string,
): Promise<PaymentResponse> {
  const { data } = await api.patch<PaymentResponse>(
    `/payments/${id}/confirm-payment`,
    { note, proofOfPaymentDocumentId },
  );
  return data;
}
